<template>
  <v-app>
    <v-app-bar
      v-if="
        currentRouteName !== 'landing page' &&
        currentRouteName !== 'reset password' &&
        currentRouteName !== 'activate account' &&
        currentRouteName !== 'waiting room candidate' &&
        currentRouteName !== 'waiting room candidate avatar' &&
        currentRouteName !== 'waiting room' &&
        currentRouteName !== 'error' &&
        currentRouteName !== 'avatar interview' &&
        currentRouteName !== 'interview' &&
        currentRouteName !== 'shared analysis'
      "
      class="topbar ma-4"
      fixed
    >
      <v-img
        :src="require('@/assets/VP_sin_fondo.png')"
        max-height="50"
        max-width="75"
        contain
        alt="Logo"
        @click="goHome()"
      />

      <v-img src="img/beonit.png" max-height="50" max-width="75" contain alt="Logo" class="ml-2" />
      <v-spacer />
      <v-menu
        v-if="notifications.length > 0"
        v-model="menu"
        offset-y
        :close-on-content-click="false"
      >
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon class="mr-1" v-on="on">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon size="24" color="primary" v-on="on">mdi-bell-badge</v-icon>
              </template>
              <span>Notifications</span>
            </v-tooltip>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(notification, index) in notifications" :key="index">
            <v-card
              class="notification-card"
              :class="
                notification.status === 'SUCCESS' ? 'notification-success' : 'notification-error'
              "
              elevation="1"
            >
              <v-list-item-content class="px-2">
                <v-row v-if="notification.type === 'CV'">
                  <v-col cols="11">
                    <p
                      v-if="notification.status === 'SUCCESS'"
                      class="mb-0 notification-link"
                      @click="openCV(notification, index)"
                    >
                      <b>{{ notification.username }}</b
                      >'s CV has been successfully analysed ({{ notification.date }})
                    </p>
                    <p v-else class="mb-0">
                      Error analysing
                      <b>{{ notification.username ? notification.username : 'Unknown User' }}</b
                      >'s CV ({{ notification.date }})
                    </p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      size="18"
                      :color="notification.status === 'SUCCESS' ? 'green' : 'red'"
                      class="mr-2"
                      @click="dismissNotification(index)"
                      >mdi-close</v-icon
                    >
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="11">
                    <template v-if="notification.status === 'SUCCESS'">
                      <p
                        v-if="notification.reason === 'Audio Analyzed'"
                        class="mb-0 notification-link"
                        @click="openInterview(notification.id, index)"
                      >
                        The audio of <b>{{ notification.username }}</b
                        >'s interview has been successfully analysed ({{ notification.date }})
                      </p>
                      <p
                        v-if="notification.reason === 'Tone Analyzed'"
                        class="mb-0 notification-link"
                        @click="openInterview(notification.id, index)"
                      >
                        The tone of <b>{{ notification.username }}</b
                        >'s interview has been successfully analysed ({{ notification.date }})
                      </p>
                      <p
                        v-if="notification.reason === 'Video Analyzed'"
                        class="mb-0 notification-link"
                        @click="openInterview(notification.id, index)"
                      >
                        The video of <b>{{ notification.username }}</b
                        >'s interview has been successfully analysed ({{ notification.date }})
                      </p>
                    </template>
                    <p v-else class="mb-0">
                      Error analysing
                      <b>{{ notification.username ? notification.username : 'Unknown User' }}</b
                      >'s interview ({{ notification.date }})
                    </p>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      size="18"
                      :color="notification.status === 'SUCCESS' ? 'green' : 'red'"
                      class="mr-2"
                      @click="dismissNotification(index)"
                      >mdi-close</v-icon
                    >
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-card>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-tooltip v-else bottom>
        <template #activator="{ on }">
          <v-btn icon disabled class="mr-1" v-on="on">
            <v-icon size="24" color="primary" v-on="on">mdi-bell-off-outline</v-icon>
          </v-btn>
        </template>
        <span>Notifications</span>
      </v-tooltip>
      <v-tooltip v-if="currentRouteName !== 'home'" bottom>
        <template #activator="{ on }">
          <v-btn icon class="mr-1" v-on="on" @click="goBack()">
            <v-icon size="24" color="primary">mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>Back</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            icon
            class="mr-1 about-button"
            aria-label="About"
            v-on="on"
            @click="aboutOpen = true"
          >
            <v-icon size="24" color="primary">mdi-information-outline</v-icon>
          </v-btn>
        </template>
        <span>About</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn icon class="mr-1" v-on="on" @click="logout()">
            <v-icon size="24" color="primary">mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>Log out</span>
      </v-tooltip>
    </v-app-bar>
    <AboutDialog v-model="aboutOpen" />
    <v-snackbar
      v-model="runSnackbar.open"
      :timeout="8000"
      :color="runSnackbar.color"
      bottom
      right
      class="run-notification-snackbar"
      data-testid="run-notification"
    >
      {{ runSnackbar.text }}
      <template #action="{ attrs }">
        <v-btn
          v-if="runSnackbar.route"
          text
          v-bind="attrs"
          class="run-notification-open"
          @click="openRunNotification"
        >
          Open
        </v-btn>
        <v-btn text v-bind="attrs" @click="runSnackbar.open = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-main
      :class="
        currentRouteName !== 'error' &&
        currentRouteName !== 'landing page' &&
        currentRouteName !== 'avatar interview' &&
        currentRouteName !== 'waiting room' &&
        currentRouteName !== 'waiting room candidate' &&
        currentRouteName !== 'waiting room candidate avatar' &&
        currentRouteName !== 'shared analysis'
          ? 'main-top'
          : ''
      "
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Vue from 'vue';
import AuthDataService from './services/AuthDataService';
import AboutDialog from '@/components/AboutDialog.vue';
import { describeRunNotification, sourceRoute } from '@/components/queue/queueFormat';
import SocketioService from '@/services/socketioService.js';

export default {
  name: 'App.vue',
  components: {
    AboutDialog,
  },
  data() {
    return {
      notifications: [],
      menu: false,
      aboutOpen: false,
      // Terminal transition of a run launched in this session (analysisQueue.notifications).
      runSnackbar: { open: false, text: '', color: 'success', route: null },
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    /** Newest run notification from the analysisQueue store (null when the module is absent). */
    latestRunNotification() {
      const list = this.$store?.state?.analysisQueue?.notifications;
      return Array.isArray(list) && list.length ? list[list.length - 1] : null;
    },
  },
  watch: {
    latestRunNotification(notification) {
      if (!notification) return;
      this.showRunNotification(notification);
    },
  },
  mounted() {
    Vue.prototype.$socket = null;

    if (localStorage.getItem('user')) {
      Vue.prototype.$socket = SocketioService.setupSocketConnection(
        JSON.parse(localStorage.getItem('user')).id,
        JSON.parse(localStorage.getItem('user')).username,
        true
      );
    }

    SocketioService.emisor.$on('notificationsSended', (data) => {
      this.notifications = data;

      this.notifications.forEach((notification) => {
        notification.date = this.convertToTimezone(notification.date);
      });
    });

    SocketioService.emisor.$on('notificationsActiveSended', (data) => {
      data.date = this.convertToTimezone(data.date);
      this.notifications.splice(0, 0, data);
      this.menu = true;
    });

    SocketioService.emisor.$on('notificationDismissed', (data) => {
      this.notifications.splice(data, 1);
    });
  },
  methods: {
    dismissNotification(index) {
      SocketioService.dismissNotification(this.$socket, index);
    },
    /** Snackbar 'Analysis of <name> finished / failed / cancelled' for watched runs (M3 F22). */
    showRunNotification(notification) {
      const { text, color } = describeRunNotification(notification);
      this.runSnackbar = {
        open: true,
        text,
        color,
        route: sourceRoute(notification),
      };
      if (this.$store)
        this.$store.dispatch('analysisQueue/dismissNotification', notification.run_id);
    },
    openRunNotification() {
      const route = this.runSnackbar.route;
      this.runSnackbar.open = false;
      if (route) this.$router.push(route).catch(() => {});
    },
    goHome() {
      this.$router.push('/home');
    },
    goBack() {
      if (this.$route.meta.backTo) {
        this.$router.push(this.$route.meta.backTo);
      } else if (this.$route.meta.useHistoryBack) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    },
    logout() {
      AuthDataService.logout().then(
        (response) => {
          if (response.status == 204) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }
        },
        (error) => {
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    openCV(cv, index) {
      cv.cvId = cv.cv_id;
      if (this.$route.name === 'cv info') {
        this.$router.replace({ name: 'cv info', params: { cv: cv } });
      } else {
        this.$router.push({ name: 'cv info', params: { cv: cv } });
      }
      this.menu = false;
      this.dismissNotification(index);
    },
    convertToTimezone(dateAndHour) {
      const date = new Date(dateAndHour);
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const localDateObj = new Date(date.toLocaleString('en-US', { timeZone }));

      const formattedDate = `${localDateObj.getHours().toString().padStart(2, '0')}:${localDateObj
        .getMinutes()
        .toString()
        .padStart(2, '0')} ${localDateObj.getDate().toString().padStart(2, '0')}-${(
        localDateObj.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${localDateObj.getFullYear().toString().slice(-2)}`;

      return formattedDate;
    },
  },
};
</script>
